module.exports = __webpack_public_path__ + "img/keyboard_N.8ef6a812.png";